import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { LoaderService } from '../../service/loader.service';
import { AuthService } from '../../service/auth.service';
import { RoleEnum } from '../../core/guards/RoleEnum.enum';
import {User} from "../../models/user.model";
import {ThemeService} from "../../service/theme.service";
import {ToastModule} from "primeng/toast";
import {GA4Service} from "../../service/ga4.service";

@Component({
  selector: 'app-from-nexus',
  templateUrl: './from-nexus.component.html',
  styleUrls: ['./from-nexus.component.scss'],
  standalone: true,
  imports: [
    ToastModule
  ]
})
export class FromNexusComponent implements OnInit {

  constructor(
    private loaderService: LoaderService,
    private route: Router,
    public themeService: ThemeService,
    private userService: AuthService,
    private router: Router,
    private ga4Service: GA4Service
  ) {
  }

  ngOnInit(): void {
    window.addEventListener('message', this.handlePostMessage);
  }

  private handlePostMessage = (event: MessageEvent) => {
    if (event.data?.type === 'init') {
      const token = event.data.token;
      const page = event.data.page;
      localStorage.setItem('user', JSON.stringify(this.userService.decrypt(decodeURIComponent(token),true)));
      const decodedUser: User = JSON.parse(localStorage.getItem('user') ?? '{}');
  
      this.userService.currentUserSource.next(decodedUser);
      if (decodedUser.contracts) {
        this.userService.setCurrentContract(decodedUser.contracts[0]);
        // Registra o acesso do usuário no GA4 quando o contrato é definido
        this.ga4Service.trackUserAccess();
      }
      this.userService.saveFromURL(decodedUser);
      if (decodedUser.accessToken && page.includes('real-time')) {
        const lastRoute = sessionStorage.getItem('lastRoute');
        const fallbackRoute = 'pages' + RoleEnum.RELATORIOS.path;
        this.router.navigateByUrl(lastRoute || fallbackRoute);
      }
      this.themeService.disableHeader();
      this.loaderService.hideLoader();
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.handlePostMessage);
  }
}
